/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TrashCanIcon16Light } from './TrashCanIcon16Light';
import { TrashCanIcon16Regular } from './TrashCanIcon16Regular';
import { TrashCanIcon16Solid } from './TrashCanIcon16Solid';
import { TrashCanIcon20Light } from './TrashCanIcon20Light';
import { TrashCanIcon20Regular } from './TrashCanIcon20Regular';
import { TrashCanIcon20Solid } from './TrashCanIcon20Solid';
import { TrashCanIcon24Regular } from './TrashCanIcon24Regular';
import { TrashCanIcon24Solid } from './TrashCanIcon24Solid';
import { TrashCanIcon32Regular } from './TrashCanIcon32Regular';
import { TrashCanIcon64Regular } from './TrashCanIcon64Regular';
var sizes = {
    16: {
        light: TrashCanIcon16Light,
        regular: TrashCanIcon16Regular,
        solid: TrashCanIcon16Solid,
    },
    20: {
        light: TrashCanIcon20Light,
        regular: TrashCanIcon20Regular,
        solid: TrashCanIcon20Solid,
    },
    24: {
        regular: TrashCanIcon24Regular,
        solid: TrashCanIcon24Solid,
    },
    32: {
        regular: TrashCanIcon32Regular,
    },
    64: {
        regular: TrashCanIcon64Regular,
    },
};
export var TrashCanIcon = forwardRef('TrashCanIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
